import React from 'react'
import Login from '../components/auth/Login'

const LoginPage = ({setUser}) => {
  return (
    <div><Login setUser={setUser}/></div>
  )
}

export default LoginPage